import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceCity from "@/views/系统设置/service/DZServiceCity";
import nyMessageToast from "@/utils/NYMessageToast";
import dzMsgBox from "@/utils/DZMessageBox";
import nyNetwork from "@/api/nyBaseNetwork";

@Component({
    components: {}
})
export default class Index extends Vue {

    level1 = "";level2 = "";level3 = "";level4 = ""

    $refs: any;

    table_height = 0

    s_city = new DZServiceCity();

    props = {
        label: 'name',
        children: 'child'
    }

    opendList = []

    created() {
        this.action_list_city()
        this.get_opened_city()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    action_list_city(){
        this.s_city.net_all_city()
    }

    get_opened_city(){
        nyNetwork.net("三级城市列表",{}, data => {
            data.forEach(a =>{
                if(a.child){
                    a.child.forEach(b =>{
                        this.opendList.push(b.id)
                    })
                }else{
                    this.opendList.push(a.id)
                }
            })
        })
    }

    /**
     * 开通
     */
    getCheckedNodes() {
        let list = this.$refs.tree.getCheckedNodes(false,true);
        let idList = []
        list.forEach(o =>{idList.push(o.id)})
        if(idList.length === 0)return
        this.s_city.net_open_city(idList)
    }
}
